import React from 'react';
import PropTypes from 'prop-types';
import ProfileMetricCard from '../../CandidateComponents/Shards/ProfileMetricCard';
import AdditionalMetricCard from '../../CandidateComponents/Shards/AdditionalMetricCard';
import StrengthsConcernsCard from '../../CandidateComponents/Shards/StrengthsConcernsCard';
import HardSkillsSection from '../../CandidateComponents/Shards/HardSkillsSection';
import SoftSkillsSection from '../../CandidateComponents/Shards/SoftSkillsSection';
import AreasOfExpertise from '../../CandidateComponents/Shards/AreasOfExpertise';
import JobResponsibilitiesFit from '../../CandidateComponents/Shards/JobResponsibilitiesFit';

/**
 * ProfileFitReportContent Component
 * Profile report content for the public report based on job_profile_fit_report_json
 */
const ProfileFitReportContent = ({ candidate }) => {
  // Check if we have profile fit data
  const hasProfileData = !!candidate?.job_profile_fit_report_json;

  if (!hasProfileData) {
    return (
      <div className="p-6">
        <div className="text-center text-gray-500 py-8">
          <div className="bg-blue-50 rounded-full p-6 mb-4 inline-block">
            <svg className="w-16 h-16 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">No Profile Data Available</h3>
          <p className="text-gray-600">Profile report data is not available for this candidate.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Conclusion and Charts Section */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6"> */}
        {/* Left column - Conclusion */}
        {/* <div className="border border-blue-200 rounded-lg p-6 bg-blue-50 relative">
          <div className="flex justify-between items-start mb-3">
            <h4 className="text-lg font-semibold text-gray-800">Conclusion</h4>
            {candidate?.job_profile_fit_report_json?.conclusion?.source && (
              <span className="text-xs text-gray-500">Source: {candidate.job_profile_fit_report_json.conclusion.source}</span>
            )}
          </div>
          <div className="h-full">
            <p className="text-gray-800 text-lg">{candidate?.job_profile_fit_report_json?.conclusion?.value || "No conclusion available."}</p>
          </div>
        </div> */}
        
        {/* Right column - Charts */}
        {/* <div className="space-y-6"> */}
          {/* General Ability Chart */}
          {/* <ProfileMetricCard
            title="General Ability"
            value={candidate?.job_profile_fit_report_json?.generalAbility?.value || 0}
            rationale={candidate?.job_profile_fit_report_json?.generalAbility?.rationale}
            source={candidate?.job_profile_fit_report_json?.generalAbility?.source}
          />
           */}
          {/* Job Fit Chart */}
          {/* <ProfileMetricCard
            title="Fit for Job"
            value={candidate?.job_profile_fit_report_json?.jobFit?.value || 0}
            rationale={candidate?.job_profile_fit_report_json?.jobFit?.rationale}
            source={candidate?.job_profile_fit_report_json?.jobFit?.source}
          />
        </div>
      </div> */}
      
      {/* Additional Metrics Section */}
      {(candidate?.job_profile_fit_report_json?.["AI Proficiency"]?.value || candidate?.job_profile_fit_report_json?.["Security Awareness"]?.value || candidate?.job_profile_fit_report_json?.["Multidisciplinary Expertise"]?.value) && (
        <div className="border border-gray-200 rounded-lg p-6 bg-white">
          <h4 className="text-xl font-semibold text-gray-800 mb-4">Additional Key Metrics</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* AI Proficiency */}
            {candidate?.job_profile_fit_report_json?.["AI Proficiency"]?.value !== undefined && (
              <AdditionalMetricCard 
                title="AI Proficiency"
                value={candidate.job_profile_fit_report_json["AI Proficiency"].value}
                rationale={candidate.job_profile_fit_report_json["AI Proficiency"].rationale}
                source={candidate.job_profile_fit_report_json["AI Proficiency"].source}
              />
            )}
            
            {/* Security Awareness */}
            {candidate?.job_profile_fit_report_json?.["Security Awareness"]?.value !== undefined && (
              <AdditionalMetricCard 
                title="Security Awareness"
                value={candidate.job_profile_fit_report_json["Security Awareness"].value}
                rationale={candidate.job_profile_fit_report_json["Security Awareness"].rationale}
                source={candidate.job_profile_fit_report_json["Security Awareness"].source}
              />
            )}
            
            {/* Multidisciplinary Expertise */}
            {candidate?.job_profile_fit_report_json?.["Multidisciplinary Expertise"]?.value !== undefined && (
              <AdditionalMetricCard 
                title="Multidisciplinary Expertise"
                value={candidate.job_profile_fit_report_json["Multidisciplinary Expertise"].value}
                rationale={candidate.job_profile_fit_report_json["Multidisciplinary Expertise"].rationale}
                source={candidate.job_profile_fit_report_json["Multidisciplinary Expertise"].source}
              />
            )}
          </div>
        </div>
      )}
      
      {/* Strengths and Concerns Section */}
      {(candidate?.job_profile_fit_report_json?.strengths?.items || candidate?.job_profile_fit_report_json?.concerns?.items) && (
        <StrengthsConcernsCard 
          strengths={{...candidate?.job_profile_fit_report_json?.strengths, value: candidate?.job_profile_fit_report_json?.strengths?.items}}
          concerns={{...candidate?.job_profile_fit_report_json?.concerns, value: candidate?.job_profile_fit_report_json?.concerns?.items}}
        />
      )}
      
      {/* Hard Skills Section */}
      {candidate?.job_profile_fit_report_json?.hardSkills?.items && candidate.job_profile_fit_report_json.hardSkills.items.length > 0 && (
        <HardSkillsSection hardSkills={{...candidate.job_profile_fit_report_json.hardSkills, value: candidate.job_profile_fit_report_json.hardSkills.items}} />
      )}
      
      {/* Soft Skills Section */}
      {candidate?.job_profile_fit_report_json?.softSkills?.items && candidate.job_profile_fit_report_json.softSkills.items.length > 0 && (
        <SoftSkillsSection softSkills={{...candidate.job_profile_fit_report_json.softSkills, value: candidate.job_profile_fit_report_json.softSkills.items, source: "Resume"}} />
      )}
      
      {/* Areas of Expertise Section */}
      {candidate?.job_profile_fit_report_json?.expertise?.items && candidate.job_profile_fit_report_json.expertise.items.length > 0 && (
        <AreasOfExpertise expertise={{...candidate.job_profile_fit_report_json.expertise, value: candidate.job_profile_fit_report_json.expertise.items}} />
      )}
      
      {/* Job Responsibilities Fit Section */}
      {candidate?.job_profile_fit_report_json?.responsibilitiesFit?.value && candidate.job_profile_fit_report_json.responsibilitiesFit.value.length > 0 && (
        <JobResponsibilitiesFit responsibilitiesFit={candidate.job_profile_fit_report_json.responsibilitiesFit} />
      )}
    </div>
  );
};

ProfileFitReportContent.propTypes = {
  candidate: PropTypes.object.isRequired
};

export default ProfileFitReportContent;
